import * as observationsActions from '../actions/types/observations';

const initialState = {
  observations: [],
  message: '',
  dataLength: 0,
  sending: false,
  error: null,
  page: 0,
  rowsPerPage: 20,
  order: 'asc',
  orderBy: 'name',
  filters: {},
  searchText: ''
};
  
export default (state, action) => {
  if (state === undefined) {
    return initialState;
  }
  if (action === undefined && action.type === undefined) {
    return initialState;
  }
  const {observations, error, message, dataLength, page, rowsPerPage, order, orderBy, searchText, filters} = action.payload;
  switch (action.type) {
  case observationsActions.FILTER_OBSERVATIONS_SENDING:
    return {...state, sending: true, page, rowsPerPage, order, orderBy, searchText, filters, dataLength};
  case observationsActions.FILTER_OBSERVATIONS_SUCCESS:
    return {...state, sending: false, observations, error: null, message: 'Constructoras obtenidas satisfactoriamente', dataLength};
  case observationsActions.FILTER_OBSERVATIONS_FAILED:
    return {...state, sending: false, observations: [], error, message, dataLength};
  case observationsActions.GET_OBSERVATIONS_SENDING:
    return {...state, sending: true};
  case observationsActions.GET_OBSERVATIONS_SUCCESS:
    return {...state, sending: false, observations, error: null, message: 'Constructoras obtenidas satisfactoriamente', dataLength};
  case observationsActions.GET_OBSERVATIONS_FAILED:
    return {...state, sending: false, observations: [], error, message, dataLength};
  default:
    return state;
  }
};
